<template>
  <div class="container">
    <div class="image-ribbon"></div>
    <div class="image-pic1"></div>
    <div class="image-pic2"></div>
    <div class="image-pic3"></div>
    <img class="image-title" src="../../../assets/images/lottery_title.png">
    <div class="record-wrapper">
      <div class="tips-text">您还剩余 {{drawnum}} 次抽奖机会<span @click="$router.push(`lucklottery?id=${$route.query.id}`)" class="nav-link">立即抽奖</span></div>
      <div class="record-title">中奖记录</div>
      <div class="record-list">
        <div class="list-inner">
          <table class="record-list__table">
            <thead>
              <tr>
                <th>奖品</th>
                <th>时间</th>
              </tr>
            </thead>
            <tbody>
              <tr v-for="item in recordList" :key="item.id">
                <td>{{item.drawname}}</td>
                <td>{{item.createdate}} {{item.createtime}}</td>
              </tr>
            </tbody>
          </table>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
  import API from '../../../interface/api'
  import wx from 'weixin-js-sdk'
  const u = navigator.userAgent
  export default {
    name: 'winnerList',
    data () {
      return {
        drawnum: 0,
        recordList: []
      }
    },
    created () {
      this.$fetch.get(API.GETMEMBERDRAWNUM, {
        examid: this.$route.query.id
      }).then(response => {
        if (response.status !== 200) {
          var message = response.message ? response.message : '抽奖次数获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.drawnum = response.data.drawnum

      }).catch(error => {
        console.log(error)
      })
      this.$fetch.get(API.MEMBERDRAWRECORD, {
        examid: this.$route.query.id
      }).then(response => {
        if (response.status !== 200) {
          var message = response.message ? response.message : '抽奖次数获取失败，请刷新！'
          this.$toast.fail(message)
          return
        }
        this.recordList = response.data

      }).catch(error => {
        console.log(error)
      })
    }
  }
</script>

<style lang="stylus" scoped>
  .container
    background-color #F25151
  .image-ribbon
    position absolute
    top 46vh
    right 0px
    width 323px
    height 404px
    background url('../../../assets/images/ribbon@2x.png') no-repeat
    background-size 323px 404px
  .image-pic1
    position absolute
    left 0px
    top 40%
    width 28px
    height 55px
    transform translateY(-50%)
    background url('../../../assets/images/lottery_pic1@2x.png') no-repeat
    background-size 28px 55px
  .image-pic2
    position absolute
    right 8%
    bottom 25%
    width 32px
    height 41px
    background url('../../../assets/images/lottery_pic2@2x.png') no-repeat
    background-size 32px 41px
    z-index 1
  .image-pic3
    position absolute
    left 10%
    bottom 5%
    width 38px
    height 48px
    background url('../../../assets/images/lottery_pic3@2x.png') no-repeat
    background-size 38px 48px
    z-index 1
  .image-title
    position relative
    display block
    width 66.5%
    height auto
    margin 25px auto 10px
    z-index 1

  .record-wrapper
    position relative
    padding-bottom 15px
    margin -90px 20px 0
    border-radius 17px
    background-color #ffffff
    overflow hidden
    .tips-text
      font-size 17px
      margin-top 110px
      color #F25151
    .nav-link
      margin-left 10px
      padding 10px
      color #2e6fde
      cursor pointer
      text-decoration underline
      &:active
        color #7ca1e0
  .record-list
    height 308px
    margin -22px 15px 0
    padding 35px 20px 20px
    border-radius 9px
    background-color #FCF7F7
    .list-inner
      width 100%
      height 100%
      overflow-y scroll
    &__table
      width 100%
      td, th
        width 50%
        font-size 13px
        line-height 17px
      td
        padding 10px 0
      th
        padding-bottom 10px
        border-bottom 1px solid #E5E5E5
  .record-title
    font-size 18px
    width 157px
    height 33px
    margin 25px auto 0
    line-height 33px
    color #ffffff
    text-align center
    border-radius 22px
    border 4px solid #ffffff
    background-color #FFD131
    position relative
</style>